import { useQuery } from 'react-query'
import { fetchBearerToken } from '../utilities/api'

export const rootBearerTokenQueryKey = 'bearerToken'

export const useFetchBearerToken = () => {
  return useQuery({
    queryKey: ['bearerToken'],
    async queryFn() {
      return fetchBearerToken()
    },
    staleTime: Infinity,
    cacheTime: Infinity
  })
}
